var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticStyle:{"list-style-type":"none","padding":"0"}},[_c('router-link',{attrs:{"to":"/contacter-nous"}},[_c('li',{staticClass:"m-3 text-primary",staticStyle:{"cursor":"pointer"}},[_vm._v("Contactez-nous")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }